import "./TromanSelect.module.less"
import Select, { GroupBase, Props, StylesConfig } from 'react-select';

const defaultNoOptionsMessage = () => "Inga träffar";

export function TromanSelect<Option = unknown, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>({isMulti, noOptionsMessage, ...props}: Omit<Props<Option, IsMulti, Group>, "styles">) {
    return (
        <Select
            isMulti={isMulti}
            noOptionsMessage={noOptionsMessage || defaultNoOptionsMessage}
            components={{
                IndicatorSeparator: () => null,
            }}
            className='react-select__container'
            classNames={{
                control: (props) => props.isFocused ? 'react-select__control react-select__focused' : 'react-select__control'
            }}
            styles={{
                container: (base, state) => ({
                    ...base,
                    fontSize: '12px',
                    width: '100%',
                }),
                control: (base, state) => ({
                    ...base,
                    minHeight: '0',
                    borderColor: state.isFocused ? '#66afe9' : base.borderColor,
                    boxShadow: state.isFocused ? '0 0 6px  #66afe9' : base.boxShadow,
                    "&:hover": {
                        borderColor: state.isFocused ? '#66afe9' : base.borderColor,
                    },
                }),
                group: (base, state) => ({
                    ...base,
                    background: '#eee',
                }),
                menu: (base, state) => ({
                    ...base,
                    zIndex: 10,
                    overflowY: 'hidden',
                    marginTop: '4px',
                }),
                dropdownIndicator: (base, state) => ({
                    ...base,
                    padding: '4px',
                }),
                multiValue: (base, state) => ({
                    ...base,
                    flexDirection: 'row-reverse',
                    width: '100%',
                    margin: '0 0 0 -6px',
                    backgroundColor: '#fff'
                }),
                multiValueLabel: (base, state) => ({
                    ...base,
                    fontSize: '12px',
                    flex: '1 1 auto',
                    paddingLeft: undefined,
                    padding: '3px 3px 1px 1px',
                }),
                clearIndicator: (base, state) => ({
                    ...base,
                    padding: '4px',
                }),
            }}
            {...props}/>
    )
};

export interface ITromanSelectOption {
    label: string;
    value: string;
}

export interface ITromanSelectGroup {
    label: string;
    options: ITromanSelectOption[];
}

export type TromanSelectOptionsOrGroups = (ITromanSelectOption | ITromanSelectGroup)[];

export interface ITromanSelectCommonProps {
    inputId?: string;
    tabIndex?: number;
    placeholder?: string;
    isDisabled?: boolean;
    options: TromanSelectOptionsOrGroups;
}

export interface ITromanSelectSingleProps extends ITromanSelectCommonProps {
    value: ITromanSelectOption|null;
    onChange: (value: ITromanSelectOption|null) => void;
}

export interface ITromanSelectMultiProps extends ITromanSelectCommonProps {
    value: readonly ITromanSelectOption[];
    onChange: (value: readonly ITromanSelectOption[]) => void;
}

// These components are primarily for use in angular
export const TromanSelectSingle = (props: ITromanSelectSingleProps) => {
    return (
        <TromanSelect
            isMulti={false}
            inputId={props.inputId}
            tabIndex={props.tabIndex}
            placeholder={props.placeholder}
            isClearable={!!props.placeholder}
            isDisabled={props.isDisabled}
            options={props.options}
            value={props.value}
            onChange={props.onChange}/>
    );
}

export const TromanSelectMulti = (props: ITromanSelectMultiProps) => {
    return (
        <TromanSelect
            isMulti={true}
            inputId={props.inputId}
            tabIndex={props.tabIndex}
            placeholder={props.placeholder}
            isClearable={false}
            isDisabled={props.isDisabled}
            options={props.options}
            value={props.value}
            onChange={props.onChange}/>
    );
}